var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [(_vm.successMsg != '') ? _c('div', [_c('div', {
    staticClass: "successMessage"
  }, [_vm._v("\n              " + _vm._s(_vm.successMsg)), _c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeSuccessMsg
    }
  })])]) : _vm._e(), _vm._v(" "), _c('legend', [_c('label', [_vm._v("User Details")]), _vm._v(" "), _c('div', {
    staticClass: "float-md-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOverride),
      expression: "isOverride"
    }],
    attrs: {
      "type": "checkbox",
      "name": "isOverride"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOverride) ? _vm._i(_vm.isOverride, null) > -1 : (_vm.isOverride)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isOverride,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOverride = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isOverride = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOverride = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("isOverride")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isHubWise),
      expression: "isHubWise"
    }],
    attrs: {
      "type": "checkbox",
      "name": "isHubWise"
    },
    domProps: {
      "checked": Array.isArray(_vm.isHubWise) ? _vm._i(_vm.isHubWise, null) > -1 : (_vm.isHubWise)
    },
    on: {
      "click": _vm.resetUseridWiseForm,
      "__c": function($event) {
        var $$a = _vm.isHubWise,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isHubWise = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isHubWise = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isHubWise = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("isHubWise")])])]), _vm._v(" "), (_vm.isHubWise) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 float-md-left"
  }, [_c('label', [_vm._v("Hub Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "z-index": "999",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.hubServiceCenterList,
      "name": "hubid",
      "id": "hubid",
      "placeholder": "Select Hub",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.getProjectData
    },
    model: {
      value: (_vm.hubid),
      callback: function($$v) {
        _vm.hubid = $$v
      },
      expression: "hubid"
    }
  })], 1), _vm._v(" "), (!_vm.hubvalidate) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n                           Please select hub.\n                     ")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isHubWise) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2 float-md-left"
  }, [_c('label', [_vm._v("User Id")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 float-md-left"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|verify_userids|max_userids'),
      expression: "'required|verify_userids|max_userids'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('userid')
    },
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": " Enter User Ids",
      "name": "userid",
      "id": "userid"
    },
    model: {
      value: (_vm.userid),
      callback: function($$v) {
        _vm.userid = $$v
      },
      expression: "userid"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text\n                        text-muted",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v("Note: Use Comma (,) for Multiple user ids. Without Space.\n                      ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('userid')),
      expression: "errors.has('userid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('userid')) + "\n                   ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2 float-md-left"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Employee Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 float-md-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emptype),
      expression: "emptype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:true'),
      expression: "'required:true'"
    }],
    staticClass: "form-control",
    class: {
      'form-control':
      true, 'error': _vm.errors.has('EmpType')
    },
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "name": "EmpType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.emptype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getProjectData]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select employee type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("SR")])]), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#4b8cbb",
      "active": _vm.isProjectloader
    },
    on: {
      "update:active": function($event) {
        _vm.isProjectloader = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('EmpType')),
      expression: "errors.has('EmpType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select employee type.")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-if=displayForm == ''"
  }, [(_vm.listProjectData != '') ? _c('div', {
    staticClass: "col-md-2 float-md-left "
  }, [_c('label', [_vm._v("Project Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listProjectData), function(project_obj, index) {
    return _c('div', {
      staticClass: "form-group row col-md-12 float-md-left"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "col-md-2 float-md-left "
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.projectidchk[project_obj.project.projectid]),
        expression: "form.projectidchk[project_obj.project.projectid]"
      }],
      class: {
        'error': _vm.errors.has('projectid')
      },
      staticStyle: {
        "font-weight": "100"
      },
      attrs: {
        "type": "checkbox",
        "name": "projectid",
        "id": project_obj.project.projectid
      },
      domProps: {
        "value": _vm.form.projectidchk[project_obj.project.projectid],
        "checked": Array.isArray(_vm.form.projectidchk[project_obj.project.projectid]) ? _vm._i(_vm.form.projectidchk[project_obj.project.projectid], _vm.form.projectidchk[project_obj.project.projectid]) > -1 : (_vm.form.projectidchk[project_obj.project.projectid])
      },
      on: {
        "change": function($event) {
          _vm.validateRole(project_obj.project.projectid, $event);
        },
        "__c": function($event) {
          var $$a = _vm.form.projectidchk[project_obj.project.projectid],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.form.projectidchk[project_obj.project.projectid],
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.form.projectidchk[project_obj.project.projectid] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.projectidchk[project_obj.project.projectid] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.form.projectidchk, project_obj.project.projectid, $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(project_obj.project.projectname)), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 float-md-left"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.projectidwiserole[project_obj.project.projectid]),
        expression: "form.projectidwiserole[project_obj.project.projectid]"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true, 'error': _vm.errors.has('projectroleid' + project_obj.project.projectid)
      },
      attrs: {
        "name": _vm.setname(project_obj.project.projectid),
        "id": _vm.setname(project_obj.project.projectid),
        "disabled": _vm.bindroleid(project_obj.project.projectid) == '' ? true : false
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.form.projectidwiserole, project_obj.project.projectid, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.removeValidation('projectroleid' + project_obj.project.projectid)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Role")]), _vm._v(" "), _vm._l((project_obj.roles), function(role_obj) {
      return _c('option', {
        domProps: {
          "value": role_obj.roleid
        }
      }, [_vm._v(_vm._s(role_obj.rolename))])
    })], 2), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('projectroleid' + project_obj.project.projectid)),
        expression: "errors.has('projectroleid'+project_obj.project.projectid)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select role.")])]), _vm._v(" "), (_vm.emptype == '2') ? _c('div', {
      staticClass: "col-md-3 float-md-left"
    }, [_c('multiselect', {
      class: {
        'form-control': true, 'error': _vm.errors.has('projectmultiroleid' + project_obj.project.projectid)
      },
      attrs: {
        "options": project_obj.roles,
        "multiple": true,
        "placeholder": "Select multiple roles",
        "track-by": "rolename",
        "label": "rolename",
        "name": 'projectmultiroleid' + project_obj.project.projectid,
        "hide-selected": true,
        "id": 'projectmultiroleid' + project_obj.project.projectid
      },
      model: {
        value: (_vm.form.projectidwisemultirole[project_obj.project.projectid]),
        callback: function($$v) {
          _vm.$set(_vm.form.projectidwisemultirole, project_obj.project.projectid, $$v)
        },
        expression: "form.projectidwisemultirole[project_obj.project.projectid]"
      }
    }, [_c('span', {
      slot: "noResult"
    }, [_vm._v("Oops! No elements found. Consider changing the search query.")])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('projectmultiroleid' + project_obj.project.projectid)),
        expression: "errors.has('projectmultiroleid'+project_obj.project.projectid)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select multiple role.")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 float-md-right"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.is_active[project_obj.project.projectid]),
        expression: "form.is_active[project_obj.project.projectid]"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true, 'error': _vm.errors.has('projectstatus' + project_obj.project.projectid)
      },
      attrs: {
        "name": _vm.setStatus(project_obj.project.projectid),
        "id": _vm.setStatus(project_obj.project.projectid),
        "disabled": _vm.bindroleid(project_obj.project.projectid) == '' ? true : false
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.form.is_active, project_obj.project.projectid, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.removeStatusValidation('projectstatus' + project_obj.project.projectid)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "",
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Action")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "true"
      }
    }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "false"
      }
    }, [_vm._v("Inactive")])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('projectstatus' + project_obj.project.projectid)),
        expression: "errors.has('projectstatus'+project_obj.project.projectid)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select Action.")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.proSel),
      expression: "form.proSel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "hidden",
      "name": "proSel"
    },
    domProps: {
      "value": (_vm.form.proSel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.proSel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('proSel')),
      expression: "errors.has('proSel')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select atleast one project")])])], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "size": "vlg"
    }
  }, [_vm._v("Save")]), _vm._v(" \n            "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "vlg"
    },
    on: {
      "click": _vm.closeRegistration
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "reset",
      "size": "vlg",
      "name": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d96a3f0","hasScoped":true}!./src/views/components/hubuseraccess/hubuseraccess.component.html
// module id = 843
// module chunks = 1